import {
  TextDisplay,
  TextDisplayHighlight,
} from '@ferreri/prever-component-lib';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { HeaderHomeNotification } from '@components/headers/HeaderHomeNotification';
import { useCreateOccurrence } from '@modules/event/event.store';
import { usePersistedGeolocation } from '@modules/geolocation/geolocation.store';
import { LocationSelect } from '@modules/location/LocationSelect';
import { useScrollToTop } from '@utils/useScrollToTop';
import { StyledContent, StyledSection } from '../../components/layouts/Layouts';
import { PublicationsCategoriesList } from '../shared/components/publications/PublicationsCategoriesList';
import { HomeGlobalSection } from './HomeGlobalSection';
import { HomeNearbySection } from './HomeNearbySection';
import { HomePartnerSection } from './HomePartnerSection';
import { HomePublicationFeaturedList } from './HomePublicationFeaturedList';
import { HomeSearchSection } from './HomeSearchSection';
import { HomeAngeplusBenefitsSection } from './HomeAngeplusBenefitsSection';

const Home = () => {
  const router = useRouter();
  const { hasCurrentGeolocation } = usePersistedGeolocation();
  useScrollToTop();
  const createOccurrenceRef = useRef(false);
  const { mutate } = useCreateOccurrence();

  useEffect(() => {
    if (createOccurrenceRef.current === false) {
      mutate({ event_type_slug: 'access_clube' });
      createOccurrenceRef.current = true;
    }
  }, [createOccurrenceRef.current]);

  useEffect(() => {
    if (!hasCurrentGeolocation && router.isReady) {
      router.replace('/location');
    }
  }, [router.isReady, hasCurrentGeolocation]);

  return (
    <>
      <LocationSelect />
      <StyledContent>
        <StyledSection>
          <HeaderHomeNotification />
          <TextDisplay>
            Compartilhar é o{' '}
            <TextDisplayHighlight>grande negócio</TextDisplayHighlight>
          </TextDisplay>
        </StyledSection>
        <HomeSearchSection />
        <PublicationsCategoriesList />
        <HomePublicationFeaturedList />
        <HomeNearbySection />
        <HomeGlobalSection />
        <HomePartnerSection />
        <HomeAngeplusBenefitsSection />
      </StyledContent>
    </>
  );
};

export default Home;
